import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { analyticsResultsGETEndipoint } from '../../../common/endpoints';

export const getAnalyticsWorkflowResults = createApi(analyticsResultsGETEndipoint,"GET");

const AnalyticsWorkflowResultsSlice = createSlice({
  name: 'AnalyticsWorkflowResultsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAnalyticsWorkflowResults.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAnalyticsWorkflowResults.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAnalyticsWorkflowResults.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default AnalyticsWorkflowResultsSlice.reducer;